import { notification } from 'antd';
import { duration } from 'moment';


const PortalAlerts = (type, title, message) => {
    
    notification[type]({
        message: "Alert",
        description: message,
        duration : 1
    });
    return null;
    
}


export default PortalAlerts